import { excludeGroups } from "@/Settings/Constants/AppendingConfig";
import { splitCamelCaseAndUpperCase } from "@/Settings/helpers/SystemSettings/appendingConfiguration";
import { IAppendingConfigurationOems, IAppendingConfigurationReference } from "@/Settings/types/Common/model";
import { IGlAccount, IRow, IWSGroup } from "@/Settings/types/SystemSettings/appendingConfiguration";
import { Grid } from "@mui/material";
import sortBy from "lodash-es/sortBy";
import AppendingConfigurationTable from "./AppendingConfigurationTable";

type TAppendingConfigNoFranchisesSectionProps = {
	data: IAppendingConfigurationReference[];
	wsGroups: IWSGroup[];
	onSaveConfiguration: (data: { finalRow?: IRow; reference: string; franchise?: string | null }) => Promise<void>;
	onRemoveConfiguration: (ids: string[]) => Promise<void>;
	onMultipleSaveConfiguration: (rows: IRow[]) => Promise<void>;
	resolveGlAccounts: () => { allSelectableGlAccounts: IGlAccount[]; filteredGlAccounts: IGlAccount[] };
	isPending: boolean;
};

const AppendingConfigNoFranchisesSection = (props: TAppendingConfigNoFranchisesSectionProps) => {
	const { data, isPending, wsGroups, onSaveConfiguration, onMultipleSaveConfiguration, onRemoveConfiguration, resolveGlAccounts } = props;

	return (
		<Grid container spacing={1} sx={{ width: "100%" }}>
			{sortBy(data, "reference").map((dataItem, i) => {
				const { oems, reference } = dataItem;

				const hideGroups = excludeGroups.includes(reference);
				const title = splitCamelCaseAndUpperCase(reference);

				const transformedData = transformData(oems);

				const keyIndex = `item-${reference}-${i}`;
				return (
					<Grid item xs={6} key={keyIndex} className="!mb-[32px]" sx={{ width: "100%" }}>
						<AppendingConfigurationTable
							data={transformedData as IRow[]}
							title={title}
							emptyMessage={title}
							hideGroups={hideGroups}
							hideOem={false}
							resolveGlAccounts={resolveGlAccounts}
							wsGroups={wsGroups}
							reference={reference}
							onSaveConfiguration={onSaveConfiguration}
							onMultipleSaveConfiguration={onMultipleSaveConfiguration}
							onRemoveConfiguration={onRemoveConfiguration}
							isPending={isPending}
						/>
					</Grid>
				);
			})}
		</Grid>
	);
};

const transformData = (oems: IAppendingConfigurationOems[]) => {
	return oems
		.map((oemItem) => {
			const { configuration, ...restOem } = oemItem;
			return configuration.map((configItem) => {
				const { data } = configItem;
				return data.map((dataItem) => {
					return { ...dataItem, oemReference: restOem.oemReference, dealerCodeFS: restOem.dealerCodeFS };
				});
			});
		})
		.flat(Infinity);
};

export default AppendingConfigNoFranchisesSection;
